<template>
  <section class="section">
    <form @submit.prevent="validateBeforeSubmit">
      <div class="container">
        <div class="columns">
          <div class="column is-10">
            <h1 class="title green">
              <span v-if="order.id != null && order.id != 0 && order.id != -1">
                {{ order.primaryCode }}
              </span>
              <span v-else>{{ title }}</span> - {{ patient.name }} -
              <span v-if="patient.shopData">{{ patient.shopData.name }}</span> -
              {{ $translate(currentStatus) | capitalize }}
            </h1>
          </div>
          <div class="column has-text-right">
            <b-field grouped position="is-right">
              <b-field>
                <a
                  v-if="
                    order.id != null && order.id !== 0 && order.id !== -1 && $store.getters.user.userInfo.type !== 'C'
                  "
                  type="button"
                  class="button is-primary"
                  @click="downloadAttach()"
                >
                  <b-icon icon="download-outline" />
                </a>
              </b-field>
              <b-field>
                <a
                  v-if="order.id !== null && order.id !== 0 && order.id !== -1"
                  type="button"
                  class="button is-danger"
                  :disabled="isDeletableBool || disabledbool"
                  @click="
                    if (!isDeletableBool && !disabledbool) {
                      deleteOccurence(order.id)
                    }
                  "
                >
                  <b-icon icon="delete-outline" />
                </a>
              </b-field>
              <b-field>
                <b-dropdown aria-role="list" position="is-bottom-left">
                  <button
                    slot="trigger"
                    type="button"
                    class="button is-primary"
                    :disabled="isSaveDisabled || disabledbool"
                  >
                    <b-icon icon="content-save-outline" />
                  </button>

                  <b-dropdown-item class="pointercursor" :disabled="disabledbool" @click="validateBeforeSubmit(true)">
                    {{ $translate('save') | capitalize }}
                  </b-dropdown-item>
                  <b-dropdown-item class="pointercursor" @click="tryvalidate()">
                    {{ $translate('check') | capitalize }}
                  </b-dropdown-item>

                  <hr class="dropdown-divider" />

                  <b-dropdown-item class="pointercursor" :disabled="disabledbool" @click="trysave('invord')">
                    <!--:disabled="disabledbool || isEnvoiableBool"-->
                    {{ $translate('save_envo') | capitalize }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="pointercursor"
                    :disabled="disabledbool || $store.getters.user.userInfo.level == '1'"
                    @click="trysave('sendord')"
                  >
                    <!--:disabled="disabledbool || isSendableBool"-->
                    {{ $translate('save_sended') | capitalize }}
                  </b-dropdown-item>

                  <hr class="dropdown-divider" />
                  <b-dropdown-item class="pointercursor" @click="printOrderFunction()">
                    <!--:disabled="currentStatus == 'compord'"-->
                    {{ $translate('print') | capitalize }}
                  </b-dropdown-item>
                  <hr v-if="!order.company.simplifiedOrder" class="dropdown-divider" />
                  <b-dropdown-item
                    v-if="!order.company.simplifiedOrder"
                    class="pointercursor"
                    @click="exportJson() /*console.log('TODO EXPORT')*/"
                  >
                    <!--:disabled="currentStatus == 'compord'"-->
                    {{ $translate('export') | capitalize }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="!order.company.simplifiedOrder"
                    class="pointercursor"
                    :disabled="sendingToMercurio"
                    @click="sendToMercurio()"
                  >
                    {{ $translate('send_to_mercurio') | capitalize }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-field>
            </b-field>
          </div>
        </div>
        <hr />

        <b-tabs v-model="activeTab" position="is-left" class="blocks" @input="changePage">
          <b-tab-item>
            <template slot="header">
              <b-icon :class="{ 'has-text-danger': pageWarning[0] }" icon="information-outline" />
              <span :class="{ 'has-text-danger': pageWarning[0] }"> {{ $translate('generalInfo') }}</span>
            </template>
            <div class="container">
              <OrderGeneralInfo
                :order.sync="order"
                :config="config"
                :patient.sync="patient"
                :pathologiesbool.sync="pathologiesbool"
                :status.sync="$status[order.module]"
                :disabledbool.sync="disabledbool"
                :current-status.sync="currentStatus"
                :is-save-disabled.sync="isSaveDisabled"
                :language.sync="language"
                :is-simplified.sync="order.company.simplifiedOrder"
              />
              <hr class="green" />
              <OrderTypologyFits
                ref="OrderTypologyFits"
                :order.sync="order"
                :bdictionary.sync="bdictionary_fits"
                :b-dictionary-name.sync="bDictionaryNameFits"
                :ddictionary.sync="ddictionary_fits"
                :d-dictionary-name.sync="dDictionaryNameFits"
                :disabledbool.sync="disabledbool"
                :is-simplified.sync="order.company.simplifiedOrder"
                @updateParent="updateChild()"
              />
            </div>
          </b-tab-item>
          <b-tab-item>
            <template slot="header">
              <b-icon :class="{ 'has-text-danger': pageWarning[2] }" icon="book-open-outline" />
              <span :class="{ 'has-text-danger': pageWarning[2] }"> {{ $translate('model') | capitalize }}</span>
            </template>
            <div class="container">
              <OrderModel
                ref="OrderModel"
                :config="config"
                :mod.sync="order.mod"
                :availablepell.sync="availablepell"
                :availablefode.sync="availablefode"
                :availablebatt.sync="availablebatt"
                :availableallacc.sync="availableallacc"
                :availablesoles.sync="availablesoles"
                :shoe-type.sync="order.shoeType"
                :catalog-type.sync="order.catalogType"
                :disabledbool.sync="disabledbool"
                :catalog-model.sync="catalog.model"
                :is-save-disabled.sync="isSaveDisabled"
                :is-simplified.sync="order.company.simplifiedOrder"
                :is-custom-hidden.sync="order.company.hideCustom"
                :order.sync="order"
                @getid="getid"
              />
            </div>
          </b-tab-item>
          <b-tab-item>
            <template slot="header">
              <b-icon :class="{ 'has-text-danger': pageWarning[3] }" icon="view-dashboard-outline" />
              <span :class="{ 'has-text-danger': pageWarning[3] }"> {{ $translate('measure_text') | capitalize }}</span>
            </template>
            <Measurements
              ref="Measurements"
              :arraytodelete.sync="arraytodelete"
              :disabledbool.sync="disabledbool"
              :is-simplified.sync="order.company.simplifiedOrder"
              :missingattachment.sync="missingattachment"
              :order.sync="order"
            />
          </b-tab-item>
          <b-tab-item>
            <template slot="header">
              <b-icon :class="{ 'has-text-danger': pageWarning[4] }" icon="card-account-details-outline" />
              <span :class="{ 'has-text-danger': pageWarning[4] }"> {{ $translate('prod_details') }}</span>
            </template>
            <!-- :availablereinforcement.sync="availablereinforcement" -->
            <ProdDetails
              :order.sync="order"
              :details="order.prod_details"
              :disabledbool.sync="disabledbool"
              :availablecont.sync="availablecont"
              :availablesott.sync="availablesott"
              :sole="order.mod.sole"
              @update="onUpdateProdDetails"
            />
          </b-tab-item>
        </b-tabs>
      </div>
    </form>
    <PrintOrder :print-order-bool.sync="printOrderBool" :orders.sync="printOrders" />

    <b-loading :is-full-page="true" :active.sync="isSaveDisabled" :can-cancel="false" />
  </section>
</template>

<script>
import '@/helpers/mixins/variables/availablematerialprod'
import '@/helpers/mixins/variables/availablematerialacc'
import '@/helpers/mixins/variables/ordertype'
import '@/helpers/mixins/variables/deliverytype'

import { modelFits } from '@/helpers/mixins/modelTools'
import orderTools from '@/helpers/mixins/orderTools'
import materialTools from '@/helpers/mixins/materialTools'
import exportTools from '@/helpers/mixins/exportTools'
import permissionMixin from '@/helpers/mixins/permissionMixin'

import OrderGeneralInfo from './components/OrderGeneralInfo'
import OrderTypologyFits from './components/OrderTypologyFits.vue'
//import AddMaterial from "./components/AddMaterial";
import OrderModel from './components/OrderModelFits.vue'
import Measurements from './components/MeasurementsFitsModular.vue'
import ProdDetails from './components/ProdDetailsFits'
import PrintOrder from './components/PrintOrder'

import firebase from 'firebase'
import keyWordGenerator from '@/helpers/mixins/keyWordGenerator.js'

import JSZip from 'jszip'
import saveAs from 'file-saver'
//import cloneDeep from "clone-deep";
import { cloneDeep, isEqual } from 'lodash'
//import request from "request";

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'OrderFormFits',
  components: {
    OrderGeneralInfo: OrderGeneralInfo,
    OrderTypologyFits,
    //AddMaterial: AddMaterial,
    OrderModel: OrderModel,
    Measurements: Measurements,
    ProdDetails: ProdDetails,
    PrintOrder: PrintOrder,
  },
  mixins: [orderTools, materialTools, permissionMixin, keyWordGenerator, exportTools],
  // props: ["orderId"],
  props: {
    orderId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      missingattachment: false,
      printOrderBool: false,
      printOrders: null,
      catalog: {},
      disabledbool: false,
      sendingToMercurio: false,
      currentStatus: null,
      pathologiesbool: null,
      bdictionary_fits: null,
      bDictionaryNameFits: '',
      dDictionaryNameFits: '',
      ddictionary_fits: null,
      pageWarning: [false, false, false, false, false],
      arraytoupload: {},
      arraytodelete: {},
      loadingData: false,
      id: -1,
      tempid: -1,
      patientId: -1,
      patient: {},
      title: 'Form Ordine',
      activeTab: 0,
      isSaveDisabled: false,
      isDeletableBool: true,
      isEnvoiableBool: true,
      isSendableBool: true,

      availablepell: [],
      availablefode: [],
      availablebatt: [],
      availablesoles: [],
      availablefogge: [],
      availableallacc: [],
      availablesott: [],
      availablecont: [],

      lastSavedOrder: {},

      order: {
        id: null,
        plan_realization: 'no_plantar',
        statusOrder: 'compord',
        send_date: null,

        pair: 'both',
        //prec_pair: "empty",

        primaryCode: null,
        catalogType: null,
        shoeType: null,

        patientId: null,
        creationDate: null,
        lastModificationDate: null,

        pathologiesLeft: [],
        pathologiesRight: [],

        materialprod: [],
        materialacc: [],

        module: 'fits',
        isPrinted: false,

        mod: {
          components_to_drill: [],
          addingchar: [],
          addingcharfod: [],
          var_ling_sx: [],
          var_ling_dx: [],
          shape_left: null,
          shape_right: null,
        },
        footmeasurements: {},
        attachment: {},
        attachmentflag: {},

        company: {
          simplifiedOrder: false,
        },
      },
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    config() {
      return this.$moduleConfiguration[this.order.module]
    },
  },
  watch: {
    order: {
      deep: true,
      handler() {
        this.isDeletableBool = this.isTransitionDoable(this.currentStatus, 'deletedord', this.order) === false
        this.isEnvoiableBool = this.isTransitionDoable(this.currentStatus, 'invord', this.order) === false
        this.isSendableBool = this.isTransitionDoable(this.currentStatus, 'sendord', this.order) === false
        this.$forceUpdate()
      },
    },
  },
  async mounted() {
    try {
      await this.initForm()
    } catch (error) {
      this.isSaveDisabled = false
      this.loadingData = false
      this.$buefy.notification.open({
        duration: 5000,
        message: this.$translate('order_loading_error'),
        type: 'is-danger',
      })
      throw error
    }
  },
  methods: {
    async initForm() {
      this.isSaveDisabled = true
      this.disabledbool = !this.$route.params.view
      this.availableallacc = []

      //const cloneDeep = require("clone-deep");

      this.$validator.extend('notnull', value => {
        return !(value === '' || value === undefined)
      })

      this.$validator.extend('unique', async value => {
        let temparray = []
        await this.$db
          .collection('orders')
          .where('primaryCode', '==', value)
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              if (doc.id !== this.id) {
                temparray.push(doc.data().primaryCode)
              }
            })
          })

        return !temparray.includes(value)
      })
      this.patientId = this.$route.params.patientId !== undefined ? this.$route.params.patientId : -1
      this.id = this.orderId ? this.orderId : -1

      /*for (var ind in this.$availableMaterials) {
        this.order.materialprod[this.$availableMaterials[ind]] = 0;
        this.order.materialacc[this.$availableMaterials[ind]] = 0;
      }*/

      //this.order.mod = new modelTailored();
      //this.order.mod = this.order.mod.returnObject();
      //this.order.mod.catalogchoose = true;
      //let oldmod = cloneDeep(this.order.mod);
      let oldmod = new modelFits().returnObject()
      oldmod.catalogchoose = true

      if (this.patientId !== -1) {
        this.order.patientId = this.patientId
      } else {
        if (this.id === -1) {
          await this.$router.push({ name: 'patients' })
        }
      }
      /*
      await this.getMaterialArray(this.availablepell, "Pel");
      await this.getMaterialArray(this.availablefode, "Acc");
      await this.getMaterialArray(this.availablebatt, "Pun");
      await this.getMaterialArray(this.availableinter, "Mor");
      await this.getMaterialArray(this.availableguard, "Mat");
      await this.getMaterialArray(this.availablegomm, "Sug");
      await this.getMaterialArray(this.availablecont, "PaS");
      await this.getMaterialArray(this.availablecont, "PaS");
      await this.getMaterialArray(this.availablesott, "Pat");
      await this.getMaterialArray(this.availablepunt, "Mez");

      await this.getMaterialArray(this.availablemoi, "Moi");
      await this.getMaterialArray(this.availablesup_plan, "Sup_plan");
      await this.getMaterialArray(this.availableriv_plan, "Riv_plan");
      */
      this.loadingData = true
      if (this.id !== -1) {
        await this.$db
          .collection('orders')
          .doc(this.id)
          .get()
          .then(doc => {
            if (!doc.exists) {
              this.lastSavedOrder = cloneDeep(this.order)
              this.$router.push({ name: 'orders' })
            }
            let orderData = doc.data()
            orderData.mod.components_to_drill = orderData.mod.components_to_drill || []
            orderData.mod.addingchar = orderData.mod.addingchar || []
            orderData.mod.addingcharfod = orderData.mod.addingcharfod || []
            orderData.mod.var_ling_sx = orderData.mod.var_ling_sx || []
            orderData.mod.var_ling_dx = orderData.mod.var_ling_dx || []
            orderData.mod.soles = orderData.mod.soles || []

            if (!orderData.pair) orderData.pair = 'both'

            //this.order = doc.data();
            //console.log(orderData.materialacc)
            //console.log(orderData.materialprod)
            if (Object.keys(orderData.materialacc).length === 0) orderData.materialacc = []
            if (Object.keys(orderData.materialprod).length === 0) orderData.materialprod = []
            //console.log(orderData.materialacc)
            //console.log(orderData.materialprod)
            this.order = orderData
            oldmod = cloneDeep(this.order.mod)

            if (this.order.attachment == null) {
              this.order.attachment = {}
            }

            if (this.order.attachmentflag == null) {
              this.order.attachmentflag = {}
            }

            /*if (!this.isEditDoable(this.order.statusOrder)) {
              this.$router.push({ name: "orders" });
            }*/
          })

        this.patientId = this.order.patientId
        await this.loadPatientStatfromOrder()
        //console.log(this.ddictionary)
      } else {
        const modelClass = new modelFits()
        //this.order.mod = new modelFits()
        this.order.mod = modelClass.returnObject()
        this.order.mod.catalogchoose = true

        await this.loadPatientStat()
        if (this.$route.params.startingorderType) {
          this.order.orderType = this.$route.params.startingorderType
        }
      }
      if (this.order.tec == null) {
        this.order.tec = this.$store.getters.user.userInfo.username
      }

      this.order.patient = this.patient
      this.currentStatus = this.order.statusOrder
      if (this.catalog === undefined) {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('catalog_missing'),
          type: 'is-danger',
        })
        this.lastSavedOrder = cloneDeep(this.order)

        await this.$router.push({ name: 'orders' })
      }

      await this.getMaterialArrayFiltered(this.availablepell, 'Pel_F', this.catalog)
      await this.getMaterialArrayFiltered(this.availablefode, 'Acc_F', this.catalog)
      await this.getMaterialArrayFiltered(this.availablebatt, 'Pun_F', this.catalog)
      await this.getMaterialArrayFiltered(this.availablefogge, 'Fog_F', this.catalog)
      await this.getMaterialArrayFiltered(this.availableallacc, 'All_F', this.catalog)
      await this.getMaterialArrayFiltered(this.availablecont, 'PaS_F', this.catalog)
      await this.getMaterialArrayFiltered(this.availablesott, 'Pat_F', this.catalog)
      this.availablesoles = await this.getMaterialArray(this.config.soles)
      const freshShapes = await this.getMaterialArray(this.config.shapes)
      this.availablesoles = this.availablesoles.map(sole => ({
        ...sole,
        shapes: sole.shapes ? sole.shapes.map(s => freshShapes.find(sh => sh.id === s.id) || s) : sole.shapes,
      }))

      await this.$nextTick()

      //this.$refs.AddMaterialprod.updateAfterload();
      //this.$refs.AddMaterialacc.updateAfterload();
      this.order.mod = cloneDeep(oldmod)
      await this.$refs.OrderModel.updateAfterload()
      //console.log('QUESTO')
      //console.log(this.$refs.Measurements)
      this.$refs.Measurements.checkValue()

      //this.lastSavedOrder = cloneDeep(this.order);
      this.lastSavedOrder = cloneDeep(this.order)
      //console.log(isEqual(this.order, this.lastSavedOrder));
      //console.log(isMatch())

      this.loadingData = false

      this.$forceUpdate()
    },
    onUpdateProdDetails(newValues) {
      this.order.prod_details = newValues
    },
    updateChild() {
      this.$forceUpdate()
      if (this.$refs.Measurements) {
        this.$refs.Measurements.checkValue()
      }
      if (this.$refs.OrderModel) {
        this.$refs.OrderModel.deliveryUpdated()
      }
    },
    printOrderFunction() {
      this.printOrders = []
      this.printOrders.push(this.order)
      this.printOrderBool = true
    },
    async getid(tempid) {
      this.tempid = tempid
      //console.log(tempid);
    },
    checkValidation() {
      //let valuetoreturn = this.isSendable(this.order)
      //valuetoreturn = !valuetoreturn
      //return valuetoreturn
      return !this.checkSend(this.order)
    },
    async downloadAttach() {
      const cloneDeep = require('clone-deep')

      this.isSaveDisabled = true
      var zip = new JSZip()
      for (var item in this.order.attachment) {
        if (this.order.attachment[item] != null) {
          if (this.order.attachment[item].name) {
            //
          } else {
            //console.log(item);
            let oldmeta = ''
            const storageRef = this.$storage.ref('order/attachment/' + this.order.id + '/' + item)
            await storageRef.getMetadata().then(metadata => {
              oldmeta = metadata.contentType
            })
            if (item.substring(item.length - 6, item.length - 3) == 'pln') {
              oldmeta = 'pln'
            } else if (item.substring(item.length - 6, item.length - 3) == 'fms') {
              oldmeta = 'fms'
            } else if (item.substring(item.length - 6, item.length - 3) == 'stl') {
              oldmeta = 'stl'
            } else if (item.substring(item.length - 6, item.length - 3) == 'una') {
              oldmeta = 'stl'
            } else {
              oldmeta = oldmeta.substr(oldmeta.length - 3)
              if (oldmeta == 'peg') {
                oldmeta = 'jpeg'
              }
            }
            await storageRef.getDownloadURL().then(async url => {
              await fetch(url).then(async htmlReturn => {
                let previousChunk = new Uint8Array()
                let fileArray = new Uint8Array()
                const reader = htmlReturn.body.getReader()
                await reader
                  .read()
                  .then(function appendStreamChunk({ done, value }) {
                    if (value) {
                      previousChunk = cloneDeep(fileArray)
                      fileArray = new Uint8Array(previousChunk.length + value.length)
                      fileArray.set(previousChunk)
                      fileArray.set(value, previousChunk.length)
                    }
                    if (done) {
                      return fileArray
                    } else {
                      return reader.read().then(appendStreamChunk)
                    }
                  })
                  .then(async file => {
                    zip.file(item + '.' + oldmeta, file)
                  })
                  .catch()
              })
            })
          }
        }
      }
      zip.generateAsync({ type: 'blob' }).then(content => {
        saveAs(
          content,
          this.$store.getters.user.userInfo.name +
            this.$store.getters.user.userInfo.surname +
            new Date().toLocaleDateString() +
            '.zip'
        )
      })
      this.isSaveDisabled = false
    },
    deleteOccurence(idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('order_message_confirm'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('order_message_destroy'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () =>
          this.$db
            .collection('orders')
            .doc(idtoerase)
            .set(
              {
                statusOrder: 'deletedord',
                deleted: true,
              },
              { merge: true }
            )
            .then(() => {
              this.lastSavedOrder = cloneDeep(this.order)

              this.$router.push({ name: 'orders' })
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
            }),
      })
    },
    changePage(index) {
      this.pageWarning[index] = false
      this.$refs.Measurements.$forceUpdate()
    },
    trysave(newstatus) {
      if (this.canUserDoTransition(this.order.statusOrder, newstatus)) {
        if (this.$store.getters.user.userInfo.type == 'C' && this.$store.getters.user.userInfo.level == '1') {
          if (newstatus == 'invord') {
            this.$validator.validateAll().then(result => {
              if (result) {
                this.$buefy.dialog.confirm({
                  title: this.$translate('attention'),
                  message: this.$translate('confirm_invord_C1'),
                  cancelText: this.$translate('undo'),
                  confirmText: this.$translate('confirm'),
                  type: 'is-danger',
                  hasIcon: true,
                  onConfirm: () => {
                    this.order.statusOrder = newstatus
                    this.validateBeforeSubmit()
                  },
                })
                return
              }
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('failed_form'),
                type: 'is-danger',
              })
            })
          } else {
            this.order.statusOrder = newstatus
            this.validateBeforeSubmit()
          }
        } else {
          if (this.$store.getters.user.userInfo.type == 'C') {
            if (newstatus == 'sendord') {
              this.$validator.validateAll().then(result => {
                if (result) {
                  this.$buefy.dialog.confirm({
                    title: this.$translate('attention'),
                    message: this.$translate('confirm_sendord_C'),
                    cancelText: this.$translate('undo'),
                    confirmText: this.$translate('confirm'),
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                      this.order.statusOrder = newstatus
                      this.validateBeforeSubmit()
                    },
                  })
                  return
                }
                this.$buefy.notification.open({
                  duration: 3000,
                  message: this.$translate('failed_form'),
                  type: 'is-danger',
                })
              })
            } else {
              this.order.statusOrder = newstatus
              this.validateBeforeSubmit()
            }
          } else {
            this.order.statusOrder = newstatus
            this.validateBeforeSubmit()
          }
        }
      } else {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('changeStatusNotPermitted'),
          type: 'is-danger',
        })
      }
    },
    notifySuccess() {
      this.$buefy.notification.open({
        duration: 3000,
        message: this.$translate('success_form'),
        type: 'is-success',
      })
    },
    tryvalidate() {
      // this.checkSend(this.order)
      this.$validator.validateAll().then(result => {
        if (result) {
          if (!this.R9F(this.order)) {
            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate('no_sole_selected'),
              type: 'is-danger',
            })
          }
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
          })
          return
        }
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('failed_form'),
          type: 'is-danger',
        })
      })
    },
    validateBeforeSubmit(simpleSave = false) {
      this.checkSend(this.order)
      if (simpleSave) {
        this.$validator.validate('primaryCode').then(result => {
          if (result) {
            if (
              this.order.statusOrder != 'compord' &&
              this.order.statusOrder != 'invord' &&
              this.order.send_date == null
            ) {
              this.order.send_date = new Date().getTime()
            }

            this.InitUpdate()
            return
          }
          this.$forceUpdate()
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('failed_form'),
            type: 'is-danger',
          })
        })
      } else {
        this.$validator.validateAll().then(result => {
          if (result) {
            if (
              this.order.statusOrder != 'compord' &&
              this.order.statusOrder != 'invord' &&
              this.order.send_date == null
            ) {
              this.order.send_date = new Date().getTime()
            }

            this.InitUpdate()
            return
          }
          this.$forceUpdate()
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('failed_form'),
            type: 'is-danger',
          })
        })
      }
    },
    async InitUpdate() {
      this.isSaveDisabled = true
      this.order.searchArray = this.generateArrayFromOrder(this.order)
      //console.log(this.order.searchArray)
      this.order.scans_sx = []
      this.order.scans_dx = []

      for (const item in this.order.attachment) {
        if (this.order.attachment[item]) {
          if (this.order.attachmentflag[item] === 0) {
            this.arraytoupload[item] = this.order.attachment[item]
          } else {
            if (this.order.attachment[item].name) {
              this.arraytoupload[item] = this.order.attachment[item]
            }
          }
        }
      }
      if (this.id === -1 && this.tempid === -1) {
        this.order.attachment = {}
        if (!this.order.statusOrder) this.order.statusOrder = 'compord'
        if (!this.order.primaryCode) this.order.primaryCode = 'draft'
        try {
          this.order.creationDate = new Date().getTime()
          const docRef = await this.$db.collection('orders').add(this.order)
          this.id = docRef.id
          this.order.id = docRef.id
        } catch (err) {
          this.$buefy.notification.open({
            duration: 3000,
            message: err,
            type: 'is-danger',
          })
          this.isSaveDisabled = false

          return
        }
      } else if (this.id === -1) {
        this.id = this.tempid
      }

      // GESTIONE ATTACHMENT
      let orderPath = `order/attachment/${this.order.id}`
      for (const item in this.arraytodelete) {
        await this.$storage.ref(`${orderPath}/${item}`).delete()
        this.order.attachment[item] = null
        this.order.attachmentflag[item] = null
      }
      this.arraytodelete = []

      for (const item in this.arraytoupload) {
        const storageRef = this.$storage.ref(`${orderPath}/${item}`)
        let fileUploaded = await storageRef.put(this.arraytoupload[item])
        let url = await fileUploaded.ref.getDownloadURL()
        this.order.attachment[item] = url
        this.order.attachmentflag[item] = 1
      }
      this.arraytoupload = []

      this.order.lastModificationDate = new Date().getTime()
      this.order.id = this.id
      this.order.deleted = this.order.statusOrder === 'deletedord'
      this.order.history = this.order.history ? this.order.history : []

      this.order.history.push({
        technician: this.$store.getters.user.userInfo.username,
        date: new Date().getTime(),
        oldStatus: this.currentStatus,
        newStatus: this.order.statusOrder,
      })

      //const orderRef = this.$db.collection('orders').doc(this.id)
      //await orderRef.update({
      //  searchArray: firebase.firestore.FieldValue.arrayUnion(...this.order.searchArray),
      //})
      //const searchArray = this.order.searchArray
      //delete this.order.searchArray
      var batch = this.$db.batch()
      var lookuppatients = this.$db.collection('patients').doc(this.order.patientId)
      batch.update(lookuppatients, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var lookupshops = this.$db.collection('shops').doc(this.order.shopId)
      batch.update(lookupshops, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var lookupcomp = this.$db.collection('companies').doc(this.order.companyId)
      batch.update(lookupcomp, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var orderupdate = this.$db.collection('orders').doc(this.id)
      batch.update(orderupdate, this.order)
      batch
        .commit()
        .then(() => {
          this.currentStatus = this.order.statusOrder
          //this.order.searchArray = searchArray
          this.isSaveDisabled = false
          //aggiorno l'oggetto per confrontare le modifiche
          this.lastSavedOrder = cloneDeep(this.order)
          //controllo se devo bloccare il form dopo il savataggio
          this.disabledbool = !this.isEditDoable(this.order.statusOrder)
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('order_saved'),
            type: 'is-success',
          })
        })
        .catch(() => {
          //console.log(err)
          this.isSaveDisabled = false

          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('error_form_server'),
            type: 'is-danger',
          })
        })
    },
    /*async OldInitUpdate() {
      this.isSaveDisabled = true
      //this.order.searchArray = []
      this.order.searchArray = this.generateKeyWord([
        this.order.patient.alias,
        this.order.patient.name, // + ' ' + this.order.patient.surname,
        this.order.patient.surname,
        this.order.primaryCode,
        this.order.id_mercury,
        //this.order.company.name,
        //this.order.shop.name,
        this.order.tec,
      ])
      this.order.scans_sx = []
      this.order.scans_dx = []
      if (this.id == -1) {
        if (this.tempid == -1) {
          let attachment = this.order.attachment
          let realStatus = this.order.statusOrder
          let realprimaryCode = this.order.primaryCode
          this.order.statusOrder = 'draft'
          this.order.primaryCode = 'draft'

          this.order.attachment = {}
          this.order.creationDate = new Date().getTime()
          await this.$db
            .collection('orders')
            .add(this.order)
            .then(docRef => {
              this.id = docRef.id
              this.order.id = docRef.id
              this.order.attachment = attachment
              this.order.statusOrder = realStatus
              this.order.primaryCode = realprimaryCode
            })
        } else {
          this.id = this.tempid
        }
      }
      for (item in this.order.attachment) {
        if (this.order.attachment[item] != null) {
          if (this.order.attachmentflag[item] == 0) {
            this.arraytoupload[item] = this.order.attachment[item]
          } else {
            if (this.order.attachment[item].name) {
              this.arraytoupload[item] = this.order.attachment[item]
            }
          }
        }
      }

      let orderPath = `order/attachment/${this.order.id}`

      for (var item in this.arraytodelete) {
        //var desertRef = this.$storage.ref(
        //  "order/attachment/" + this.order.id + "/" + item
        //);
        //await desertRef.delete().then(function () {});
        //console.log(error);
        //});
        await this.$storage.ref(`${orderPath}/${item}`).delete()
        this.order.attachment[item] = null
        this.order.attachmentflag[item] = null
        //console.log(`deleted ${item}`)
      }
      this.arraytodelete = []

      for (item in this.arraytoupload) {
        const storageRef = this.$storage.ref(`${orderPath}/${item}`)
        let fileUploaded = await storageRef.put(this.arraytoupload[item])
        //console.log(fileUploaded)
        let url = await fileUploaded.ref.getDownloadURL()
        //console.log(url)
        this.order.attachment[item] = url
        this.order.attachmentflag[item] = 1
        //delete this.arraytoupload[item]

        //const storageRef = this.$storage.ref("order/attachment/" + this.order.id + "/" + item);
        //await storageRef
        //  .put(this.arraytoupload[item])
        //  .then(async (snapshot) => {
        //    await snapshot.ref.getDownloadURL().then((url) => {
        //      this.order.attachment[item] = url;
        //      this.order.attachmentflag[item] = 1;
        //      delete this.arraytoupload[item];
        //    });
        //  });
      }

      this.arraytoupload = []

      this.order.lastModificationDate = new Date().getTime()
      this.order.id = this.id
      if (this.order.statusOrder == 'deletedord') {
        this.order.deleted = true
      } else {
        this.order.deleted = false
      }
      if (!this.order.history) {
        this.order.history = []
      }

      this.order.history.push({
        technician: this.$store.getters.user.userInfo.username,
        date: new Date().getTime(),
        oldStatus: this.currentStatus,
        newStatus: this.order.statusOrder,
      })

      var batch = this.$db.batch()
      var lookuppatients = this.$db.collection('patients').doc(this.order.patientId)
      batch.update(lookuppatients, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var lookupshops = this.$db.collection('shops').doc(this.order.shopId)
      batch.update(lookupshops, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var lookupcomp = this.$db.collection('companies').doc(this.order.companyId)
      batch.update(lookupcomp, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var orderupdate = this.$db.collection('orders').doc(this.id)
      batch.update(orderupdate, this.order)
      batch
        .commit()
        .then(() => {
          this.currentStatus = this.order.statusOrder

          this.isSaveDisabled = false
          //aggiorno l'oggetto per confrontare le modifiche
          this.lastSavedOrder = cloneDeep(this.order)
          //controllo se devo bloccare il form dopo il savataggio
          this.disabledbool = !this.isEditDoable(this.order.statusOrder)
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('order_saved'),
            type: 'is-success',
          })
        })
        .catch(() => {
          //console.log(err);
          this.isSaveDisabled = false

          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('error_form_server'),
            type: 'is-danger',
          })
        })

      //this.$router.push({ name: "orders" });
    },*/
    exportJson() {
      this.exportFormOrderJson(this.order, this.id)
    },
    async sendToMercurio() {
      if (this.sendingToMercurio) return
      this.sendingToMercurio = true
      await this.sendFormOrderToMercurio(this.order, this.id)
      this.sendingToMercurio = false
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!isEqual(this.order, this.lastSavedOrder)) {
      if (!window.confirm(this.$translate('confirm_exit_from_order'))) {
        return
      }
    }
    next()
  },
}
</script>
<style scoped>
.container >>> .field-label .label {
  text-align: left;
}
</style>
